import React from "react";
import Slider from "react-slick";

import VacationCard from "./vacationcard";

const VacationCardCarousel = ({ cards }) => {
  var sliderParams = {
    accessibility: true,
    // arrows: true,
    dots: true,
    draggable: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="col small-gap-slider">
      <Slider {...sliderParams}>
        {cards.map((item, i) => {
          return (
            <VacationCard
              key={i}
              title={item.name}
              cardText={item.preview_text}
              to={item.url}
              img={item.fields.preview_picture}
            ></VacationCard>
          );
        })}
      </Slider>
    </div>
  );
};

export default VacationCardCarousel;
